import { initials, specialistGradient } from "@lifter/hub-ui/browser-shared";
import { cn } from "../../lib/cn";
import { AvatarTooltip } from "../identity/AvatarTooltip";

type UserAvatarSize = "sm" | "md" | "lg";

interface UserAvatarProps {
  name: string;
  size?: UserAvatarSize;
  className?: string;
  gradientSeed?: string;
  tooltip?: boolean;
}

const SIZE_STYLES: Record<UserAvatarSize, string> = {
  sm: "size-[var(--space-6)] type-eyebrow",
  md: "size-[var(--space-8)] type-meta",
  lg: "size-[var(--space-10)] type-label",
};

export function UserAvatar({
  name,
  size = "md",
  className,
  gradientSeed,
  tooltip = true,
}: UserAvatarProps) {
  return (
    <AvatarTooltip
      className={cn(
        "inline-flex shrink-0 items-center justify-center rounded-[var(--radius-pill)] bg-[var(--color-surface-2)] font-[var(--type-weight-extrabold)] text-[var(--color-text-secondary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--focus-ring-color)]",
        gradientSeed && "text-[var(--color-surface)]",
        SIZE_STYLES[size],
        className,
      )}
      data-user-avatar="true"
      disabled={!tooltip}
      name={name}
      style={gradientSeed ? { background: specialistGradient(gradientSeed) } : undefined}
    >
      <span aria-hidden="true">{initials(name)}</span>
    </AvatarTooltip>
  );
}
